export const defaultHedgeSimulationForm = {
  swap: true,
  swapFloor: true,
  cap: true,
  zeroCostCollar: false,
};
